@if (breadcrumbs()) {
  @if (divider()) {
    <span class="w-full flex mb-4 mt-2 border-t-[1px] border-benzGrey-200"></span>
  }
  <span class="bg-white flex" [innerHTML]="breadcrumbs()"></span>
}
